import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { WEBFONT_URL } from '@xingternal/malt-constants';
import PropTypes from 'prop-types';

const deleteWebfontEntriesFromStorage = () => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    Object.keys(global.localStorage || {})
      .filter(key => key.indexOf('/webfont-') > -1)
      .forEach(key => global.localStorage.removeItem(key));
  } catch (err) {}
};

class HeadBlock extends Component {
  static displayName = 'HeadBlock';

  static propTypes = {
    withWebfont: PropTypes.bool,
  };

  componentDidMount() {
    const { withWebfont } = this.props;

    if (withWebfont) {
      // We used to cache webfonts in localStorage
      // and would like to it clean up so users do not end up
      // with the font in their storage indefinitely
      deleteWebfontEntriesFromStorage();
    }
  }

  render() {
    const { withWebfont } = this.props;

    // we need to use the explicit variant here (no children)
    // refactoring due to https://source.xing.com/frontend/malt/issues/2965
    // see helmet repo https://github.com/nfl/react-helmet/issues/373
    let props = {
      meta: [
        {
          charset: 'utf-8',
        },
        {
          name: 'viewport',
          content: 'width=device-width, minimum-scale=1, maximum-scale=1',
        },
      ],
    };

    if (withWebfont) {
      props.link = [{ rel: 'stylesheet', href: WEBFONT_URL }];
    }

    if (process.env.NODE_ENV === 'development') {
      props = {
        ...props,
        bodyAttributes: { class: 'development' },
        noscript: [
          {
            innerHTML: `
  <style type="text/css">
    body {
      visibility: visible;
    }
  </style>
`,
          },
        ],
        style: [
          {
            cssText: `
  body {
    visibility: hidden;
  }
`,
          },
        ],
      };
    }

    return <Helmet {...props} />;
  }
}

export default HeadBlock;
